/// <reference path='../_all.ts' />

module blog {
  'use strict';

  export class BlogDetailCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
      '$mdDialog',
      'blogService',
      '$compile',
      '$element',
    ];

    constructor(
      private $scope: IBlogDetailCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
      private $mdDialog: ng.material.IDialogService,
      private blogService: IBlogService, 
      private $compile : ng.ICompileService,
      private $element : ng.IRootElementService
    ) {
      
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
    }

    locals: { entry: editor.Content }
    
    public $onInit(): void {
      this.$scope.entry = this.locals.entry;
      var cnt = this.$compile('<div class="blog-page">' + this.locals.entry.ContentHtml + '</div>')( this.$scope );

       
      this.$element.find('md-dialog-content p').append(cnt);

      if (this.$scope.entry.ContentMeta.Attachment) {
        this.$scope.extension = this.$scope.entry.ContentMeta.Attachment.substring(this.$scope.entry.ContentMeta.Attachment.indexOf(".") + 1)
      }
      this.$scope.filename = this.$scope.entry.ContentMeta.RoutedURL;
      this.$scope.gaPath = "/Download/" + this.$scope.entry.ContentFilter.FilterString2 + "/" + this.$scope.meta("hl") + "/" + this.$scope.filename;
    }

    closeDialog() {
      this.$mdDialog.hide();
    }

  }
}